import { createAction, props } from '@ngrx/store';
import { AppSessionState } from './app-session.state';

export const setAppSession = createAction('[AppSession] Set', props<{ session: AppSessionState }>());
export const clearAppSession = createAction('[AppSession] Clear');
export const hydrateAppSession = createAction('[AppSession] Hydrate', props<{ session: AppSessionState }>());
